import { Box, Container, Typography, styled } from '@mui/material';

const FooterWrapper = styled(Container)(
  ({ theme }) => `
        margin-top: ${theme.spacing(4)};
`
);

function Footer() {
  return (
    <FooterWrapper className="footer-wrapper">
      <Box
        pb={4}
        pt={2}
        display={{ xs: 'block', md: 'flex' }}
        alignItems="center"
        textAlign={{ xs: 'center', md: 'left' }}
        justifyContent="space-between"
        sx={{
          borderTop: (theme) => `1px solid ${theme.colors.alpha.black[10]}`
        }}
      >
        <Box>
          <Typography variant="subtitle2" sx={{ pt: 2 }}>
            &copy; 2026 - AYOZAT TLC
          </Typography>
        </Box>
      </Box>
    </FooterWrapper>
  );
}

export default Footer;
